import { render, staticRenderFns } from "./SmsConversationsSidePanel.vue?vue&type=template&id=4fc3a3de&scoped=true&"
import script from "./SmsConversationsSidePanel.vue?vue&type=script&lang=js&"
export * from "./SmsConversationsSidePanel.vue?vue&type=script&lang=js&"
import style0 from "./SmsConversationsSidePanel.vue?vue&type=style&index=0&id=4fc3a3de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc3a3de",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Flocal%2Fbamboo-home%2Flocal-working-dir%2F56885249%2FEIPSMS-UB-DB%2Fsrc%2Fcomponents%2FSmsSidePanel%2FSmsConversationsSidePanel.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports